import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { DishCard } from '@/entities/dish'
import { Offcanvas } from '@/entities/offcanvas'
import { useMenuItemDish } from '@/shared/api/dishes'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/applications/limitations/limitation/$limitationId/allergens/dish/$dishId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { data, isLoading, isError } = useMenuItemDish({
    id: '496c3732-d4b4-47d3-835f-9033928e79d2',
  })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка блюда')}>
      <DishCard dish={data?.item} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
